import { useGetMeQuery } from 'API/BaseApi';

export const useGetMyTokenData = () => {
  const { data } = useGetMeQuery();

  return data?.decryptedToken;
};
